import { IPage, IPageData, IPageDataV2, IPageDataV4 } from '@df/catalog/cms/cms-model.interface';
import { TLoadDependeciesParams } from '@df/catalog/model';
import { NgInject } from '@df/ng/ng-inject';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { NICmsContentPageType } from '@icms/core/content/interfaces/icms-content-page-type.interfaces';
import { ICmsModel } from '../model/icms-model';
import { IModelWithPosition, sortByPosition } from '../model/icms-model-position';

/**
 * Page model representing WP pages
 */
export class ICmsPage<T extends IPageData = IPageData> extends ICmsModel<T> implements IPage<IPageData> {
    /**
     * Object type id
     * @type {String}
     */
    static override readonly type = 'page';

    /**
     * If model is routable
     * @type {Boolean}
     */
    static override readonly routable = true;

    /**
     * Max verbosity level
     * @type {Number}
     */
    override maxVerbosity = 4; // 4 is cms

    /**
     * If uses drafts
     */
    override usesDrafts = true;

    /**
     * If model uses cms top bar for saving, undo and redo
     */
    override usesMainSaveBar = true;

    /**
     * Services
     */
    @NgInject(ICmsContentService)
    private iCmsContentService!: ICmsContentService;

    /**
     * Parent page getter
     */
    get parent(): ICmsPage | undefined {
        return this.data?.parent ? (this.resources.page.getExisting(this.data.parent) as ICmsPage) : undefined;
    }

    /**
     * Children pages getter
     */
    get children(): ICmsPage[] {
        return sortByPosition(
            this.resources.page
                .getAllExisting(undefined, this.data?.store)
                .filter(page => page.data?.parent === this.id) as IModelWithPosition[]
        ) as ICmsPage[];
    }

    // protected dataGetter() {
    //     if (this.verbosity >= CMS_VERBOSITY && this._data && (<IPageDataV4>this._data)._cms === undefined) {
    //         let parent: Page;

    //         if (this._data.parent) {
    //             parent = this.resources.page.getExisting(this._data.parent);
    //         }

    //         (<IPageDataV4>this._data)._cms = preparePageData(this._data, parent?._data)._cms;
    //     }

    //     return super.dataGetter();
    // }

    // protected sanitize() {
    //     if (this.verbosity >= CMS_VERBOSITY && cms['page'] && this._data) {
    //         if ((<IPageDataV4>this._data)._cms === undefined) {
    //             let parent: Page;

    //             if (this._data.parent) {
    //                 parent = this.resources.page.getExisting(this._data.parent);
    //             }

    //             (<IPageDataV4>this._data)._cms = preparePageData(this._data, parent?._data)._cms;
    //         }

    //         cms['page'].sanitizePage(<Page<IPageDataV4>>this);
    //     }
    // }

    /**
     * Loads children pages
     */
    loadChildren(verbosity: number = 1, params: TLoadDependeciesParams | undefined): Promise<ICmsPage[]> | void {
        return this.resources.page.find({ filter: { parent: this.id }, verbosity }, params);
    }

    override get name() {
        return this.data?.name?.toString() || '';
    }

    get url() {
        return this.data?.url?.toString() || '';
    }

    get ancestors(): ICmsPage[] {
        return this.parent ? [this.parent, ...this.parent.ancestors] : [];
    }

    get pageType() {
        if (this.data) {
            return this.data.pageType || NICmsContentPageType.defaultPageTypeId;
        }
        return undefined;
    }
    protected override sanitize(data: T) {
        // inject self breadcrumb if not present
        if (!('breadcrumbs' in data) && data.verbosity > 2) {
            (data as IPageDataV2).breadcrumbs = [
                {
                    label: data.name,
                    url: data.url
                }
            ];
        }

        return super.sanitize(data);
    }

    protected override getInitialDataForSanitizer(data: T): Partial<T> {
        // const fs = this.iCmsContentService.getPageTypeFields(data.pageType || NICmsContentPageType.defaultPageTypeId);

        return this.iCmsContentService.initFieldset<T, ICmsPage>(
            this.iCmsContentService.getPageTypeFields(data.pageType || NICmsContentPageType.defaultPageTypeId),
            this,
            {}
        );
    }
}
